import {SisName} from 'util/SisName';
import {BSCollectionStateType} from 'module/BSCollection/reducer/BSCollectionReducer';
import {BSCollectionByID, BSModelType} from 'module/BSCollection/type/BSCollectionStateType';
import {Booking, Holiday, IstZeit, KoKeyConf, Persurl, PlanEvent, StatusForecast, StTagZu, TaskZu, V2, V2Data} from 'generated/JavaTOmodifications';
import {SisNameBS} from 'module/BSCollection/type/SisNameBS';
import {Selector} from 'reselect'
import {createObjectSelector} from 'reselect-map'
import {selEntryDescById} from 'module/edesc/selector/EntryDescSelector'
import {transformBSToEntryDescId} from 'module/edesc/EntryDescUtil'
import {EntryDescStateType} from 'module/edesc/reducer/EntryDescReducer'

const EMPTY = {}

function selByIdGen<T extends BSModelType>(sisName: SisNameBS): Selector<BSCollectionStateType, BSCollectionByID<T>> {
	return (state: BSCollectionStateType) => {
		const ns = state.BSCollection[sisName]
		return (ns?.byId || EMPTY) as BSCollectionByID<T>
	}
}

function selConvertedGen<T extends Persurl | Booking | PlanEvent>(sisName: SisName.Persurl | SisName.Booking | SisName.PlanEvent) {
	return createObjectSelector<BSCollectionStateType & EntryDescStateType, T, EntryDescStateType['EntryDesc']['byId'], T>(
		selByIdGen<T>(sisName),
		selEntryDescById,
		(model, entryDescById) => transformBSToEntryDescId(entryDescById, model) as T,
	)
}

export const selBSCollectionByIdDict = {
	[SisName.Persurl]: selConvertedGen<Persurl>(SisName.Persurl),
	[SisName.Booking]: selConvertedGen<Booking>(SisName.Booking),
	[SisName.V2]: selByIdGen<V2>(SisName.V2),
	[SisName.V2Data]: selByIdGen<V2Data>(SisName.V2Data),
	[SisName.Ist]: selByIdGen<IstZeit>(SisName.Ist),
	[SisName.StTagZu]: selByIdGen<StTagZu>(SisName.StTagZu),
	[SisName.Holiday]: selByIdGen<Holiday>(SisName.Holiday),
	[SisName.TaskZu]: selByIdGen<TaskZu>(SisName.TaskZu),
	[SisName.StatusForecast]: selByIdGen<StatusForecast>(SisName.StatusForecast),
	[SisName.PlanEvent]: selConvertedGen<PlanEvent>(SisName.PlanEvent),
	[SisName.KoKeyConf]: selByIdGen<KoKeyConf>(SisName.KoKeyConf),
}

export const selBSCollectionOwnerDateTimestamps = {
	[SisName.Persurl]: (state: BSCollectionStateType) => state.BSCollection[SisName.Persurl]?.ownerDateFetchTimestamps || {},
	[SisName.Booking]: (state: BSCollectionStateType) => state.BSCollection[SisName.Booking]?.ownerDateFetchTimestamps || {},
	[SisName.V2]: (state: BSCollectionStateType) => state.BSCollection[SisName.V2]?.ownerDateFetchTimestamps || {},
	[SisName.Ist]: (state: BSCollectionStateType) => state.BSCollection[SisName.Ist]?.ownerDateFetchTimestamps || {},
	[SisName.StTagZu]: (state: BSCollectionStateType) => state.BSCollection[SisName.StTagZu]?.ownerDateFetchTimestamps || {},
	[SisName.Holiday]: (state: BSCollectionStateType) => state.BSCollection[SisName.Holiday]?.ownerDateFetchTimestamps || {},
	[SisName.TaskZu]: (state: BSCollectionStateType) => state.BSCollection[SisName.TaskZu]?.ownerDateFetchTimestamps || {},
	[SisName.StatusForecast]: (state: BSCollectionStateType) => state.BSCollection[SisName.StatusForecast]?.ownerDateFetchTimestamps || {},
	[SisName.PlanEvent]: (state: BSCollectionStateType) => state.BSCollection[SisName.PlanEvent]?.ownerDateFetchTimestamps || {},
	[SisName.KoKeyConf]: (state: BSCollectionStateType) => state.BSCollection[SisName.KoKeyConf]?.ownerDateFetchTimestamps || {},
}